import { render, staticRenderFns } from "./RenderRegistration.vue?vue&type=template&id=c615ab6e&scoped=true&"
import script from "./RenderRegistration.vue?vue&type=script&lang=js&"
export * from "./RenderRegistration.vue?vue&type=script&lang=js&"
import style0 from "./RenderRegistration.vue?vue&type=style&index=0&id=c615ab6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c615ab6e",
  null
  
)

export default component.exports